<script setup>
import {useLanguageStore} from "@/pinia";
const languageStore = useLanguageStore();

const emits = defineEmits(['close']);
const closeBtn = ()=>{
  emits('close');
}
</script>

<template>
<div class="btn">
    <button class="closeBtn" @click="closeBtn">{{languageStore.get('close')}}</button>
</div>
</template>

<style scoped>
.closeBtn {
  background-color: #7c838a !important;
}

button {
  min-width: 70px;
  padding: 0 12px;
  color: white;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  background-color: #052C65;
  margin: 10px;
  height: 35px;
  font-size: 1rem;
  white-space: nowrap;
}


</style>